import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavbarDateShareService {
  private data = new BehaviorSubject('');
  private dataSearch = new BehaviorSubject('');
  private dataSearchClear = new BehaviorSubject('');
  private dataLatestComment = new BehaviorSubject('');
  private loadScreenData = new BehaviorSubject('');
  private shareNotification = new BehaviorSubject('');
  private clearDashboardFilter = new BehaviorSubject('');



  data$ = this.data.asObservable();
  dataSearch$ = this.dataSearch.asObservable();
  dataSearchClear$ = this.dataSearchClear.asObservable();
  dataLatestComment$ = this.dataLatestComment.asObservable();
  loadScreenData$ =  this.loadScreenData.asObservable();
  shareNotification$ = this.shareNotification.asObservable();
  clearDashboardFilter$ = this.clearDashboardFilter.asObservable();


  changeData(data: string) {
    this.data.next(data)
  }
  searchData(data: string) {
    this.dataSearch.next(data)
  }
  searchDataClear(data: string) {
    this.dataSearchClear.next(data)
  }
  setlatestcomment(data: string) {
    this.dataLatestComment.next(data)
  }
  loaderLoad(data: string) {
    this.loadScreenData.next(data);
  }
  shareNotificationFn(data){
    this.shareNotification.next(data)
  }
  clearDashboardFilterr(data) {
    this.clearDashboardFilter.next(data);
  }

  private dataSponsorID = new BehaviorSubject('');
  dataSponsorID$ = this.dataSponsorID.asObservable();
  setSponsorID(data: string) {
    this.dataSponsorID.next(data)
  }
  private dataSponsorName = new BehaviorSubject('');
  dataSponsorName$ = this.dataSponsorName.asObservable();
  setSponsorName(data: string) {
    this.dataSponsorName.next(data)
  }
  private dataBrandName = new BehaviorSubject('');
  dataBrandName$ = this.dataBrandName.asObservable();
  setBrandName(data: string) {
    this.dataBrandName.next(data)
  }
  private dataPhaseName = new BehaviorSubject('');
  dataPhaseName$ = this.dataPhaseName.asObservable();
  setPhaseName(data: string) {
    this.dataPhaseName.next(data)
  }

  private dataCongressName = new BehaviorSubject('');
    dataCongressName$ = this.dataCongressName.asObservable();
    setCongressName(data: string) {
      this.dataCongressName.next(data)
  }

  private dataBrandID = new BehaviorSubject('');
  dataBrandID$ = this.dataBrandID.asObservable();
  setBrandID(data: string) {
    this.dataBrandID.next(data)
  }

  private dataIndicationID = new BehaviorSubject('');
  dataIndicationID$ = this.dataIndicationID.asObservable();
  setIndicationID(data: string) {
    this.dataIndicationID.next(data)
  }

  private dataPhaseID = new BehaviorSubject('');
  dataPhaseID$ = this.dataPhaseID.asObservable();
  setPhaseID(data: string) {
    this.dataPhaseID.next(data)
  }

  private dataCongressID = new BehaviorSubject('');
  dataCongressID$ = this.dataCongressID.asObservable();
  setCongressID(data: string) {
    this.dataCongressID.next(data)
  }

  private dataCategoryID = new BehaviorSubject(null);
  dataCategoryID$ = this.dataCategoryID.asObservable();
  setCategoryID(data: any) {
    this.dataCategoryID.next(data)
  }

  private chartsClick = new BehaviorSubject(false);
  chartsClick$ = this.chartsClick.asObservable();
  setchartsClick(data: any) {
    this.chartsClick.next(data)
  }

  private isNotify = new BehaviorSubject(false);
  isNotify$ = this.isNotify.asObservable();
  setisNotify(data: boolean) {
    this.isNotify.next(data)
  }

  private dmNotify = new BehaviorSubject(null);
  dmNotify$ = this.dmNotify.asObservable();
  setdmNotify(data: any) {
    this.dmNotify.next(data)
  }

  private docNotify = new BehaviorSubject(null);
  docNotify$ = this.docNotify.asObservable();
  setdocNotify(data: any) {
    this.docNotify.next(data)
  }

  private comNotify = new BehaviorSubject(null);
  comNotify$ = this.comNotify.asObservable();
  setcomNotify(data: any) {
    this.comNotify.next(data)
  }

  private frenchiseUpdate = new BehaviorSubject(null);
  frenchiseUpdate$ = this.frenchiseUpdate.asObservable();
  setfrenchiseUpdate(data: any) {
    this.frenchiseUpdate.next(data)
  }

  private askMe = new BehaviorSubject(null);
  askMe$ = this.askMe.asObservable();
  setaskMe(data: boolean) {
    this.askMe.next(data)
  }

  private showBot = new BehaviorSubject(false);
  showBot$ = this.showBot.asObservable();
  setshowBot(data: boolean) {
    this.showBot.next(data)
  }

  private closeChatEvent = new BehaviorSubject(false);
  closeChatEvent$ = this.closeChatEvent.asObservable();
  setcloseChatEvent(data: boolean) {
    this.closeChatEvent.next(data)
  }

  private assistantId = new BehaviorSubject(null);
  assistantId$ = this.assistantId.asObservable();
  setassistantId(data: any) {
    this.assistantId.next(data)
  }

  private actualDocId = new BehaviorSubject(null);
  actualDocId$ = this.actualDocId.asObservable();
  setactualDocId(data: any) {
    this.actualDocId.next(data)
  }

  private currentDocId = new BehaviorSubject(null);
  currentDocId$ = this.currentDocId.asObservable();
  setcurrentDocId(data: any) {
    this.currentDocId.next(data)
  }

  private chatBotDocCount = new BehaviorSubject(0);
  chatBotDocCount$ = this.chatBotDocCount.asObservable();
  setchatBotDocCount(data: any) {
    this.chatBotDocCount.next(data)
  }

  private IsChartShow = new BehaviorSubject(false);
  IsChartShow$ = this.IsChartShow.asObservable();
  setIsChartShow(data: any) {
    this.IsChartShow.next(data)
  }

  private IsNlpClear = new BehaviorSubject(false);
  IsNlpClear$ = this.IsNlpClear.asObservable();
  setIsNlpClear(data: any) {
    this.IsNlpClear.next(data)
  }

  private IsshowNewRobo = new BehaviorSubject(false);
  IsshowNewRobo$ = this.IsshowNewRobo.asObservable();
  setIsshowNewRobo(data: any) {
    this.IsshowNewRobo.next(data)
  }

  private IsshowNewChatWindow = new BehaviorSubject(false);
  IsshowNewChatWindow$ = this.IsshowNewChatWindow.asObservable();
  setIsshowNewChatWindow(data: any) {
    this.IsshowNewChatWindow.next(data)
  }

  private IsChatMini = new BehaviorSubject(false);
  IsChatMini$ = this.IsChatMini.asObservable();
  setIsChatMini(data: any) {
    this.IsChatMini.next(data)
  }

  private aiSearchText = new BehaviorSubject("");
  aiSearchText$ = this.aiSearchText.asObservable();
  setaiSearchText(data: any) {
    this.aiSearchText.next(data)
  }

  private aiBotModalSearch = new Subject<any>();
  aiBotModalSearch$ = this.aiBotModalSearch.asObservable();
  setAiBotModalSearch(data: any) {
    this.aiBotModalSearch.next(data);
  }

  private authCode = new BehaviorSubject("");
  authCode$ = this.authCode.asObservable();
  setauthCode(data: any) {
    this.authCode.next(data)
  }
}
